import { Card, CardContent } from '@material-ui/core'
import React from 'react'
import ProductMasterAddForm from './ProductMasterAddPage'
import pathMap from 'src/paths/pathMap'
import withFormState from '../../../components/aciacehighway/hocs/withFormState'

function AddPage({ history, showNotification, onSetLoading }) {
  return (
    <Card>
      <CardContent>
        <ProductMasterAddForm
          history={history}
          showNotification={showNotification}
          onPostSubmitSuccess={(datum) => {
            history.push(`${pathMap.AES_PRODUCT_MASTER}/edit/${datum.id}`)
          }}
          onSetLoading={onSetLoading}
        />
      </CardContent>
    </Card>
  )
}

export default withFormState(AddPage)
